import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-spinner-dialog',
    templateUrl: './spinner-dialog.component.html',
    standalone: false
})
export class SpinnerDialogComponent {

  title: string = '';
  body: string = '';
  close: string = '';

  constructor(public dialogRef: MatDialogRef<SpinnerDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data) {
    this.title = data.title;
    this.body = data.body;
    this.close = data.close;
  }

}
